// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/aircraft-brakes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/aircraft-brakes/aircraft-brakes.js';

mount([g0]);
